import { render } from "./EditSetXRM.vue?vue&type=template&id=f7e24818"
import script from "./EditSetXRM.vue?vue&type=script&lang=js"
export * from "./EditSetXRM.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__